// 公共组件注册

import Vue from 'vue';
import AppBaseMain from '@/views/layout/components/module/app-base-main';
import AppOutlineMain from '@/views/layout/components/module/app-outline-main';
import AppOutlineContent from '@/views/layout/components/module/app-outline-content';
import AppLeftTag from '@/views/layout/components/module/app-left-tag';
import AppLeftRight from '@/views/layout/components/module/app-left-right';
import AppLeftRightStow from '@/views/layout/components/module/app-left-right-stow';
import AppTopTabs from '@/views/layout/components/module/app-top-tabs';

import AppFilterGroup from '@/views/layout/components/module/app-filter-group'
import AppFilterItem from '@/views/layout/components/module/app-filter-item'
import GjButton from '@/components/button/gj-button.vue'
import GjDropdownButton from '@/components/button/gj-dropdown-button.vue'
import GjButtonGroup from '@/components/button/gj-button-group.vue'
import GjCompareBar from '@/components/compare-bar/gj-compare-bar.vue'
import GjDatePicker from '@/components/date-picker/gj-date-picker.vue'
import GjSelectDatePicker from '@/components/date-picker/gj-select-date-picker.vue'
import GjDatePickerActive from '@/components/date-picker/gj-date-picker-active.vue'
import GjSelectDatePickerActive from '@/views/modules/finance/finance-profit-report/modal/gj-select-date-picker-active.vue'
import GjDropdownItem from '@/components/dropdown/gj-dropdown-item.vue'
import GjDropdown from '@/components/dropdown/gj-dropdown.vue'
import GjInput from '@/components/input/gj-input.vue'
import GjSearchInput from '@/components/input/gj-search-input.vue'
import GjLazyInput from '@/components/input/gj-lazy-input.vue'
import GjSelectInput from '@/components/input/gj-select-input.vue'
import GjModal from '@/components/modal/gj-modal.vue'
import GjPagination from '@/components/pagination/gj-pagination.vue'
import GjCountryServerSelect from '@/components/select/gj-country-server-select.vue'
import GjOperationStateSelect from '@/components/select/gj-operation-state-select.vue'
import GjSelect from '@/components/select/gj-select.vue'
import GjVirtualSelect from '@/components/select/gj-virtual-select.vue'
import GjVirtualSelectMore from '@/components/select/gj-virtual-select-more'
import GjAccountSelect from '@/components/select/gj-account-select.vue'
import GjAddSelect from '@/components/select/gj-add-select.vue'
import GjMarketSelect from '@/components/select/gj-market-select.vue'
import GjCreatorSelect from '@/components/select/gj-creator-select.vue'
import GjLogisticsSelect from '@/components/select/gj-logistics-select.vue'
import GjBrandSelect from '@/components/select/gj-brand-select.vue'
import GjCategorySelect from '@/components/select/gj-category-select.vue'
import GjAllCategorySelect from '@/components/select/gj-all-category-select.vue'
import GjCountrySelect from '@/components/select/gj-country-select.vue'
import GjWarehouseSelect from '@/components/select/gj-warehouse-select.vue'
import GjTreeSelect from '@/components/select/gj-tree-select.vue'
import GjVxeTable from '@/components/table/gj-vxe-table.vue'
import GjLogTable from '@/components/table/gj-log-table.vue'
import GjText from '@/components/text/gj-text.vue'
import GjDesc from '@/components/text/gj-desc.vue'
import GjDescGroup from '@/components/text/gj-desc-group.vue'
import GjSettingModal from '@/components/tool-group/components/gj-setting-modal.vue'
import GjSettingCustomModal from '@/components/tool-group/components/gj-setting-custom-modal'
import GjToolGroup from '@/components/tool-group/gj-tool-group.vue'
import GjTooltip from '@/components/tooltip/gj-tooltip.vue'
import GjImage from '@/components/image/gj-image.vue'
import GjAlert from '@/components/alert/gj-alert.vue'
import GjImportAlert from '@/components/alert/gj-import-alert.vue'
import GjExplainAlert from '@/components/alert/gj-explain-alert.vue'
import GjTextAlert from '@/components/alert/gj-text-alert.vue'
import GjUpload from '@/components/upload/gj-upload.vue'
import GjUploadAttach from '@/components/upload/gj-upload-attacth.vue'
import GjUploadVideo from '@/components/upload/gj-upload-video.vue'
import GjUploadImg from '@/components/upload/gj-upload-img.vue'
import GjRadioGroup from '@/components/radio/gj-radio-group.vue'
import GjEditInput from '@/components/input/gj-edit-input'
import GjPopover from '@/components/popover/gj-popover'
import GjPopoverPanel from '@/components/popover/gj-popover-panel'
import GjLogModal from '@/components/modal/gj-log-modal'
import GjInfoModal from '@/components/modal/gj-info-modal'
import GjDatePickerModal from '@/components/modal/gj-date-picker-modal'
import GjTextareaModal from '@/components/modal/gj-textarea-modal'
import GjIcon from '@/components/icon/gj-icon.vue'
import GjTextarea from '@/components/input/gj-textarea.vue'
import GjCheckboxGroup from '@/components/checkbox/gj-checkbox-group.vue'
import GjCheckbox from '@/components/checkbox/gj-checkbox.vue'
import GjTag from '@/components/tag/gj-tag.vue'
import GjRequired from '@/components/text/gj-required';
import GjSwitch from '@/components/switch/gj-switch';
import GjHelp from '@/components/help/gj-help';
import GjBadge from '@/components/badge/gj-badge';
import GjAreaTitle from '@/components/common/gj-area-title';
import GjTreeManager from '@/components/tree/gj-tree-manager';
import GjLink from '@/components/link/gj-link';
import GjSteps from '@/components/steps/gj-steps';
import GjStep from '@/components/steps/gj-step';
import GjEmpty from '@/components/empty/gj-empty';
import GjLocalTime from '@/components/statistic/gj-local-time';
import GjTimeSelect from '@/components/time-picker/gj-time-select';
import GjCopyIcon from '@/components/icon/gj-copy-icon';
import GjSupplierSelect from '@/components/select/gj-supplier-select';
import GjChargerSelect from '@/components/select/gj-charger-select';

import EditCustomFeeModal from '@/views/modules/finance/finance-profit-report/table/modal/edit-custom-fee-modal';
import GjAnalysisPanel from '@/components/panel/gj-analysis-panel';
import GjSeparator from '@/components/separator/gj-separator';
import GjRate from '@/components/rate/gj-rate';
import ViewSetting from '@/views/components/view-setting/view-setting';
import GjTreeTable from '@/components/table/gj-tree-table.vue';
import GjExpandTable from '@/components/table/gj-expand-table.vue';
import GjBaseTable from '@/components/table/gj-base-table.vue';

import GjCard from "@/components/card/gj-card"
import GjBreadcrumb from "@/components/breadcrumb/gj-breadcrumb"
import GjCarousel from '@/components/carousel/gj-carousel.vue'
import GjVideo from '@/components/video/gj-video.vue'


// const componentFiles = require.context('@/components', true, /\.vue$/);

// const components = componentFiles.keys().map(modulePath => {
//   console.log(`import ${a(componentFiles(modulePath).default.name.split('-')[0])}${a(componentFiles(modulePath).default.name.split('-')[1])} from '@/components/${modulePath}'`);
//   return componentFiles(modulePath).default;
// });

// function a(name) {
//   return name.charAt(0).toUpperCase() + name.slice(1);
// }

const Plugin = {
  install: function (Vue) {
    Vue.component('edit-custom-fee-modal', EditCustomFeeModal);
    Vue.component('app-base-main', AppBaseMain);
    Vue.component('app-outline-main', AppOutlineMain);
    Vue.component('app-outline-content', AppOutlineContent);
    Vue.component('app-left-right', AppLeftRight);
    Vue.component('app-left-right-stow', AppLeftRightStow);
    Vue.component('app-left-tag', AppLeftTag);
    Vue.component('app-top-tabs', AppTopTabs);
    Vue.component('app-filter-group', AppFilterGroup);
    Vue.component('app-filter-item', AppFilterItem);
    Vue.component('gj-button', GjButton);
    Vue.component('gj-dropdown-button', GjDropdownButton);
    Vue.component('gj-button-group', GjButtonGroup);
    Vue.component('gj-compare-bar', GjCompareBar);
    Vue.component('gj-date-picker', GjDatePicker);
    Vue.component('gj-select-date-picker', GjSelectDatePicker);
    Vue.component('gj-date-picker-active', GjDatePickerActive);
    Vue.component('gj-select-date-picker-active', GjSelectDatePickerActive);
    Vue.component('gj-dropdown', GjDropdown);
    Vue.component('gj-dropdown-item', GjDropdownItem);
    Vue.component('gj-input', GjInput);
    Vue.component('gj-search-input', GjSearchInput);
    Vue.component('gj-lazy-input', GjLazyInput);
    Vue.component('gj-select-input', GjSelectInput);
    Vue.component('gj-modal', GjModal);
    Vue.component('gj-pagination', GjPagination);
    Vue.component('gj-country-server-select', GjCountryServerSelect);
    Vue.component('gj-operation-state-select', GjOperationStateSelect);
    Vue.component('gj-select', GjSelect);
    Vue.component('gj-virtual-select', GjVirtualSelect);
    Vue.component('gj-virtual-select-more', GjVirtualSelectMore);
    Vue.component('gj-account-select', GjAccountSelect);
    Vue.component('gj-add-select', GjAddSelect);
    Vue.component('gj-market-select', GjMarketSelect);
    Vue.component('gj-warehouse-select', GjWarehouseSelect);
    Vue.component('gj-creator-select', GjCreatorSelect);
    Vue.component('gj-logistics-select', GjLogisticsSelect);
    Vue.component('gj-brand-select', GjBrandSelect);
    Vue.component('gj-category-select', GjCategorySelect);
    Vue.component('gj-all-category-select', GjAllCategorySelect);
    Vue.component('gj-country-select', GjCountrySelect);
    Vue.component('gj-tree-select', GjTreeSelect);
    Vue.component('gj-table', GjVxeTable);
    Vue.component('gj-log-table', GjLogTable);
    Vue.component('gj-tree-table', GjTreeTable);
    Vue.component('gj-expand-table', GjExpandTable);
    Vue.component('gj-base-table', GjBaseTable);
    Vue.component('gj-text', GjText);
    Vue.component('gj-desc', GjDesc);
    Vue.component('gj-desc-group', GjDescGroup);
    Vue.component('gj-setting-modal', GjSettingModal);
    Vue.component('gj-setting-custom-modal', GjSettingCustomModal);
    Vue.component('gj-tool-group', GjToolGroup);
    Vue.component('gj-tooltip', GjTooltip);
    Vue.component('gj-image', GjImage);
    Vue.component('gj-alert', GjAlert);
    Vue.component('gj-import-alert', GjImportAlert);
    Vue.component('gj-explain-alert', GjExplainAlert);
    Vue.component('gj-upload', GjUpload);
    Vue.component('gj-upload-attach', GjUploadAttach);
    Vue.component('gj-upload-video', GjUploadVideo);
    Vue.component('gj-upload-img', GjUploadImg);
    Vue.component('gj-text-alert', GjTextAlert);
    Vue.component('gj-radio-group', GjRadioGroup);
    Vue.component('gj-icon', GjIcon);
    Vue.component('gj-edit-input', GjEditInput);
    Vue.component('gj-popover', GjPopover);
    Vue.component('gj-log-modal', GjLogModal);
    Vue.component('gj-info-modal', GjInfoModal);
    Vue.component('gj-date-picker-modal', GjDatePickerModal);
    Vue.component('gj-textarea-modal', GjTextareaModal);
    Vue.component('gj-textarea', GjTextarea);
    Vue.component('gj-checkbox-group', GjCheckboxGroup);
    Vue.component('gj-checkbox', GjCheckbox);
    Vue.component('gj-tag', GjTag);
    Vue.component('gj-required', GjRequired);
    Vue.component('gj-switch', GjSwitch);
    Vue.component('gj-help', GjHelp);
    Vue.component('gj-badge', GjBadge);
    Vue.component('gj-area-title', GjAreaTitle);
    Vue.component('gj-tree-manager', GjTreeManager);
    Vue.component('gj-popover-panel', GjPopoverPanel);
    Vue.component('gj-link', GjLink);
    Vue.component('gj-steps', GjSteps);
    Vue.component('gj-step', GjStep);
    Vue.component('gj-empty', GjEmpty);
    Vue.component('gj-local-time', GjLocalTime);
    Vue.component('gj-time-select', GjTimeSelect);
    Vue.component('gj-copy-icon', GjCopyIcon);
    Vue.component('gj-supplier-select', GjSupplierSelect);
    Vue.component('gj-analysis-panel', GjAnalysisPanel);
    Vue.component('gj-separator', GjSeparator);
    Vue.component('gj-charger-select', GjChargerSelect);
    Vue.component('gj-rate', GjRate);
    Vue.component('view-setting', ViewSetting);
    Vue.component('gj-view-setting', ViewSetting);
    Vue.component('gj-card', GjCard);
    Vue.component('gj-breadcrumb', GjBreadcrumb);
    Vue.component('gj-carousel', GjCarousel);
    Vue.component('gj-video', GjVideo);
  },
};

Vue.use(Plugin);
